import styled from "styled-components";

import { sideBarStyles } from "../sideBarStyles";

const SideBarStyle = styled.aside`
    ${sideBarStyles}
`;

export const SideBarHTML = styled(SideBarStyle).attrs(() => ({ className: "aevi-side-bar" as string }))``;
